import { useEffect, useState } from 'react';
import clsx from 'clsx';
import portrait from '../../assets/editorial/3_foto.png';
import signature from '../../assets/editorial/3_assinatura.png';
import { editorial } from '../../editorial/editorialData';
import { useFontsReady } from '../../editorial/useFontsReady';
import { accessMeta } from './accessMeta';
import EditorialPageFrame from '../../components/EditorialPageFrame';
import ProgressCircle from '../../components/ProgressCircle';

const Closing = ({ onResetPages, setChapterComplete }) => {
  const fontsReady = useFontsReady();
  const [showCircle, setShowCircle] = useState(false);
  const { groups } = editorial.closing;
  const [meta] = useState(() => accessMeta(new Date()));

  useEffect(() => {
    if (!fontsReady) return undefined;
    const timer = setTimeout(() => setShowCircle(true), 1600);
    return () => clearTimeout(timer);
  }, [fontsReady]);

  const restart = () => {
    setChapterComplete(true);
    onResetPages();
  };

  return (
    <EditorialPageFrame meta={meta} layout="closing">
      <div className={clsx('closing-layout', fontsReady && 'is-on')}>
        <p className="closing-group closing-piece">{groups[0]}</p>
        <p className="closing-group closing-group--emphasis closing-piece">{groups[1]}</p>
      </div>
      <figure className={clsx('closing-portrait closing-piece', fontsReady && 'is-on')}>
        <img src={portrait} alt="Retrato em preto e branco de Anne Frank sorrindo." />
        <img className="closing-sign" src={signature} alt="Assinatura de Anne Frank" />
      </figure>
      <aside className="closing-note">
        <p className="closing-note-title">Nota editorial</p>
        <p>
          Os textos deste documento são adaptações para o português brasileiro dos trechos fornecidos nas imagens do projeto. Não constituem transcrição de uma edição brasileira autorizada. Antes da publicação, conferir o texto com a tradução licenciada e aprovada para o projeto, incluindo pontuação, supressões e destaques.
        </p>
      </aside>
      <ProgressCircle visible={showCircle} label="Voltar à capa" glyph="close" onClick={restart} />
    </EditorialPageFrame>
  );
};

export default Closing;
